
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/editorSearch/EditorSearchPanel/EditorSearchPanel.scss.css.virtualfile';
        module.exports = {"overlay":"_overlay_7yzc7_7","container":"_container_7yzc7_15"};